// extracted by css-extract-rspack-plugin
var _1 = "extractors-LivvML";
var _2 = "table-UJpvmy";
export { _1 as "extractors", _2 as "table" }
